import '@vfde-brix/interaction-list/dist/styles.css';
import { createInteractionListBlock } from '@vfde-brix/interaction-list';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-interaction-list', createInteractionListBlock, NO_PATTERN_BUSINESS_LOGIC, element => element);
